import {
  DashboardState,
  ESdChangeReason,
  IDisplayItem,
  IFillStyle,
  IScreenInput,
  IScreenOutput,
  IStylingBorder,
  IStylingEffects,
  IStylingPosition,
  IStylingShadow,
  IStylingTypography
} from "@kuika/kuika-cl-model";
import { IIdName } from "../../../../models/interface/id-name";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { ShortcutListenerForNavigation } from "../../../common/shortcut-listeners/shortcut-listener-for-navigation";
import { ShortcutListenerForToolbar } from "../../../common/shortcut-listeners/shortcut-listener-for-toolbar";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTooltip from "../../../ui-kit/kuika-tooltip/kuika-tooltip";

export interface ISaveState {}

export interface ISaveProps {}

export interface IScreenDesignExportData {
  screenName: string;
  componentsUsedInScreen: IIdName[];
  usedStylings: ISdExportUsedStylings;
  displayItems: IDisplayItem[];
  screenInputs?: IScreenInput[];
  screenOutputs?: IScreenOutput[];
}

export interface ISdExportUsedStylings {
  stylingTypography: IStylingTypography[];
  stylingBorder: IStylingBorder[];
  stylingShadow: IStylingShadow[];
  stylingPosition: IStylingPosition[];
  stylingFill: IFillStyle[];
  stylingEffects: IStylingEffects[];
}

class Save extends PureSdComponent<ISaveProps & IWithSDProps & IWithContextProp, ISaveState> {
  constructor(props: ISaveProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {};
  }

  isUserHasAccess = (roleCode: string) => {
    return KMainFunctions.hasUserAccessInWorkspaceByProjectRole(roleCode, this.props.sd?.project?.projectAccess);
  };

  screenHasDisplayItems = (): boolean => {
    if (!this.props.sd.getScreenDesign().displayItems) return false;
    if (!this.props.sd.getScreenDesign().displayItems[0]) return false;
    if (!this.props.sd.getScreenDesign().displayItems[0].children) return false;
    if (this.props.sd.getScreenDesign().displayItems[0].children.length === 0) return false;
    return true;
  };

  saveScreen = async () => {
    await this.props.sd.saveScreen();
  };

  render() {
    return (
      <>
        {this.props.sd.dashboardState === DashboardState.design ||
          (this.props.sd.dashboardState === DashboardState.reportDesigner && <ShortcutListenerForToolbar />)}
        <ShortcutListenerForNavigation />
        {this.props.sd.dashboardState === DashboardState.reportDesigner && (
          <>
            <KuikaTooltip content="Save">
              {/* The md rung, like every other action in this row (Preview, WF Engine, validate,
                  AI chat). At sm it drew 26x24: an 18px glyph in a 24px square, wider than the
                  square it sits in and shorter than its neighbours. */}
              <KuikaButton
                data-testid="headerSaveButton"
                onClick={() => this.saveScreen()}
                isIcon
                type="tertiary"
                color="neutral"
                size="md"
              >
                <KuikaSvg width={16} height={16} name="save" />
              </KuikaButton>
            </KuikaTooltip>
          </>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const save = withContext<ISaveProps>(withSD<ISaveProps>(Save));
export { save as Save };
